import React from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/dist/client/router';
import { useTranslation } from '$hooks';
import { mq } from '$lib/helpers';
import { BackLink } from '$components/elements/back-link';

export const BasketBack = () => {
    const router = useRouter();
    const { translate } = useTranslation();

    return (
        <BasketBackSection>
            <BackLink onClick={() => router.push('/')}>{translate('checkout.checkoutBasket.back')}</BackLink>
        </BasketBackSection>
    );
};

const BasketBackSection = styled.div(({ theme }) => ({
    paddingTop: theme.space[8],
    marginBottom: theme.space[7],

    [mq('md')]: {
        paddingTop: theme.space[7],
    },
}));
